import Clouds from 'components/Clouds'
import FrontElement from 'components/FrontElement'
import StandardParagraph from 'components/StandardParagraph'
import ImageCaption from 'components/ImageCaption/ImageCaption'
// Profile Images
import GigiOeriImage from './Images/GigiOeri.png'
import Hayek from './Images/Hayek.png'
import RainerMarcFrey from './Images/RainerMarcFrey.png'
import Rolex from './Images/RolexCrown.png'
import NameImage from 'components/NameImage'
// Jet Images
import HBJIP from './Images/HBJIP.jpg'
import HBVRF1 from './Images/HBVRF1.jpg'
import HBVYM from './Images/HBVYM.png'
import HBJFX from './Images/HBJFX.jpg'

export const localeFR: Locale = {
  clouds: {
    title: (
      <>
        Les émissions de CO<sub>2</sub> d’un Suisse ou d’une Suissesse comparées
        avec celles du jet de Gigi Oeri
      </>
    ),
    lead: (
      <>
        En tonnes de CO<sub>2</sub> par année
      </>
    ),
    swissPerson: 'Suisse moyen',
    privateJet: 'Jet de Gigi Oeri',
    hintTitle: 'Source:',
    hintText: 'Mouvements aériens Opensky et propres calculs',
  },
  infoBoard: {
    distance: 'Distance parcourue',
    date: 'Date',
  },
  scrollyTellingFrontContent: [
    <FrontElement>
      <NameImage>
        <img src={GigiOeriImage} alt='Gigi Oeri' />
        <h3>Gigi Oeri</h3>
      </NameImage>
      <StandardParagraph>
        L'héritière bâloise de Roche, Gigi Oeri, vole dans un Falcon 2000LX du
        constructeur français Dassault. Selon l'équipement, ce jet peut
        accueillir entre 8 et 13 passagers et passagères. Il brûle près de 1000
        litres de kérosène par heure de vol, ce qui correspond à 2,5 tonnes de
        CO<sub>2</sub>.
      </StandardParagraph>
      <StandardParagraph>
        En 2022, le jet utilisé par Gigi Oeri a décollé exactement 129 fois. Le
        plus souvent, c’était pour effectuer le même trajet: Bâle-Ibiza ou
        Ibiza-Bâle. L'année dernière, le Falcon a effectué une centaine de vols
        sur ce trajet. Au total, le jet a émis en 2022 environ 600 tonnes de
        CO<sub>2</sub>. Cela correspond à plus de 40 fois la consommation annuelle d'un
        Suisse ou d'une Suissesse, tous les domaines de la vie réunis.
      </StandardParagraph>
      <StandardParagraph>
        Gigi Oeri réside à la fois à Bâle et à Ibiza. Un de ses porte-parole
        confirme que «Mme Oeri utilise un avion privé pour les voyages de et
        vers sa résidence secondaire à Ibiza en raison de la situation
        insulaire». On ne sait pas à quelle fréquence Gigi Oeri monte
        personnellement à bord, ni combien de passagers et passagères prennent
        chaque fois l'avion. Les vols seraient «si possible combinés avec des
        interventions pour des fondations d'utilité publique de Madame Oeri»,
        poursuit le porte-parole. L'impact environnemental de tous les vols
        serait «entièrement compensé».
      </StandardParagraph>
      <img src={HBJIP} alt='HB-JIP Jet' />
      <ImageCaption>Le jet Falcon utilisé par Gigi Oehri</ImageCaption>
      <StandardParagraph>
        Le porte-parole n'explique pas exactement ce qui est fait pour le compte
        des fondations. Divers articles de presse espagnols datant de 2017
        livrent certaines précisions à ce sujet. Selon ces articles, une
        fondation de Gigi Oeri transporterait en jet privé des chiens de rue
        d'Ibiza vers la Suisse en vue de leur adoption. Jusqu'en 2017, plusieurs
        centaines de chiens auraient été transportés de cette manière. La
        fondation gère un refuge pour chiens aussi bien à Ibiza qu'en Suisse.
        <Clouds />
      </StandardParagraph>
    </FrontElement>,
    <FrontElement>
      <NameImage>
        <img src={Hayek} alt='Hayek' />
        <h3>Familie Hayek</h3>
      </NameImage>
      <StandardParagraph>
        Le dernier décollage de l'Embraer Phenom 300 a eu lieu fin avril de
        Granges (SO) en direction de Barcelone. Ce jet relativement petit,
        pouvant accueillir jusqu'à 8 personnes, est particulièrement apprécié
        des voyageurs d'affaires, car il est relativement bon marché (8 à 10
        millions de dollars). Le jet appartient à la famille Hayek, qui a créé
        la société Manhag SA spécialement pour l'exploitation de l'avion. Le
        siège de cette société se trouve à Meisterschwanden (AG), soit au même
        endroit que le domicile familial des Hayek. Naila et Nick, sœur et
        frère, font partie du conseil d'administration, tout comme le fils de
        Naila, Marc Hayek.
      </StandardParagraph>
      <img src={HBVYM} alt='HB-VYM Jet' />
      <ImageCaption>Le jet Embraer des Hayek</ImageCaption>
      <StandardParagraph>
        L'avion est très utilisé. Les données de vol de 2022 montrent que
        l'avion a décollé 149 fois cette année-là et qu'il a passé 158 heures
        dans les airs. Le jet se dirigeait particulièrement souvent vers
        l'aérodrome de Granges, souvent depuis des destinations proches comme
        Genève ou Zurich. De Granges, il n'y a qu’une quinzaine de minutes en
        voiture jusqu'au siège principal du groupe Swatch à Bienne (BE). Nick
        Hayek – qui possède lui-même une licence de pilote – aime aussi prendre
        son hélicoptère pour travailler au siège de l'entreprise. Il le gare
        simplement sur la pelouse devant le bâtiment. Cela lui donnerait un
        sentiment d'indépendance, comme il l'a dit un jour au journal «Die
        Welt». Le jet Hayek se rend régulièrement à Barcelone. Des vols vers
        Londres, Berlin et Paris sont également documentés. L'an dernier,
        l'avion a émis au total quelque 240 tonnes de CO<sub>2</sub>.
      </StandardParagraph>
      <StandardParagraph>
        Notre rédaction aurait aimé que Nick Hayek s'exprime sur le pourquoi de
        ces vols et sur la compatibilité avec les objectifs de durabilité de
        Swatch. Mais malgré plusieurs demandes, il n'a pas répondu à nos
        questions.
      </StandardParagraph>
    </FrontElement>,

    <FrontElement>
      <NameImage>
        <img src={RainerMarcFrey} alt='Rainer-Marc Frey' />
        <h3>Rainer-Marc Frey</h3>
      </NameImage>
      <StandardParagraph>
        Au milieu de la nuit du 23 août 2022, à 1 h 21 précises, le PC-24 du
        pionnier des hedge funds et pilote amateur Rainer-Marc Frey a décollé
        d'Ostrava, en République tchèque, en direction de la Lituanie. De là, il
        s'est immédiatement dirigé vers la Lettonie, puis l'Estonie. À l'aube,
        l'avion a atterri à Turku, en Finlande. De là, direction la Suède, le
        Danemark, le Luxembourg et plusieurs autres pays européens, jusqu'à ce
        que le PC-24 de Rainer-Marc Frey atterrisse finalement à Budapest le
        soir à 23 h 07.
      </StandardParagraph>
      <StandardParagraph>
        Ce 23 août 2022, le jet a effectué 14 vols individuels avec 14
        décollages et atterrissages, brûlant plus de 7000 litres de kérosène, ce
        qui correspond à environ 18 tonnes de CO<sub>2</sub> – plus que ce qu'un Suisse
        moyen produit en une année.
      </StandardParagraph>
      <StandardParagraph>
        Pendant que Rainer-Marc Frey effectuait ce «tour d’Europe», les journaux
        suisses publiaient ce 23 août 2022 des articles sur une étude de l'EPFZ
        selon laquelle la surface des glaciers suisses a diminué de deux tiers
        au cours des nonante dernières années. Le même jour, le portail ref.ch
        publiait un article sur l'Afrique intitulé: «La sécheresse aggrave la
        famine». Et lors d'une manifestation organisée à Berne sous le slogan
        «How to Save the Planet» (ndlr: comment sauver la planète), l'ancien
        vice-président américain Al Gore a averti que dans certaines régions du
        monde, la limite de la capacité de survie de l'homme a été atteinte, en
        cet été caniculaire.
      </StandardParagraph>
      <StandardParagraph>
        Selon la liste des plus riches de «Bilanz», Rainer-Marc Frey est
        milliardaire et un inconditionnel de l'aviation. D’après le magazine
        économique, il a envoyé l'année dernière ce SMS à ses amis: «DONE
        193/193 United Nations Countries Visited» – il a visité tous les pays du
        monde, de préférence à bord de son propre jet.
      </StandardParagraph>
      <img src={HBVRF1} alt='PC-24 Jet' />
      <ImageCaption>Le PC-24 de Rainer-Marc Frey</ImageCaption>
      <StandardParagraph>
        Malgré plusieurs demandes, Rainer-Marc Frey n'a pas répondu à nos
        questions concernant ses innombrables vols et l'impact environnemental
        qui en résulte. Mais une publication sur le site web recordsetters.com
        révèle néanmoins le contexte de sa virée en jet du 23 août 2022: avec un
        ami, Rainer-Marc Frey a établi un nouveau record mondial du nombre de
        pays visités en une journée. Outre le jet, un hélicoptère et des
        voitures ont été utilisés pour battre ce record.
      </StandardParagraph>
      <StandardParagraph>
        Concernant la question du climat, Rainer-Marc Frey, debout devant son
        PC-24, explique dans une vidéo sur le site web en question: «Pendant
        notre préparation, nous avons souvent discuté de la faisabilité d'un tel
        projet.» La solution pour avoir bonne conscience: «Nous compensons notre
        empreinte carbone d'un facteur deux auprès de Myclimate.»
      </StandardParagraph>
    </FrontElement>,
    <FrontElement>
      <NameImage>
        <img src={Rolex} alt='Rolex Logo' />
        <h3>Rolex</h3>
      </NameImage>
      <StandardParagraph>
        Le fabricant suisse de montres de luxe Rolex possède pas moins de deux
        jets d'entreprise qui se déplacent fréquemment, même sur de courtes
        distances. Ainsi, l'année dernière, les jets Rolex ont régulièrement
        effectué les trajets Genève-Gênes, Genève-Milan, Genève-Zurich ou
        Genève-Paris, bien qu'il existe des liaisons ferroviaires rapides entre
        ces villes. Avec des émissions de CO<sub>2</sub> de près de 4,5 tonnes par heure de
        vol, les deux jets de Bombardier comptent parmi les plus polluants.
      </StandardParagraph>
      <img src={HBJFX} alt='HB-JFX Jet' />
      <ImageCaption>L'un des deux jets Bombardier de Rolex</ImageCaption>
      <StandardParagraph>
        L'utilisation intensive des deux avions de l'entreprise se traduit par
        une empreinte carbone importante: plus de 3000 tonnes de CO<sub>2</sub> ont été
        émises par les deux avions en 2022. Cela va à l'encontre de l’initiative
        Perpetual Planet, un engagement de Rolex contre le changement
        climatique. Depuis plus de vingt ans, la marque soutient en effet des
        activistes, comme le défenseur des océans Titouan Bernicot, qui s'engage
        pour la préservation des récifs coralliens dans le Pacifique Sud. Dans
        un article de relations publiques très élaboré, Rolex décrit par exemple
        comment Titouan Bernicot a compris que les coraux constituaient une base
        de subsistance pour l'écosystème marin. «Mais si l'eau devient trop
        chaude, par exemple, ils produisent des produits chimiques nocifs [...]
        en conséquence, les coraux perdent leurs couleurs [...] de nombreux
        coraux ne survivent pas», peut-on ainsi lire sur le site internet de
        Rolex. Au lieu de lutter contre le réchauffement des océans, Rolex
        finance l'équipe de Bernicot, qui plante et cultive des coraux selon un
        procédé complexe. «Rolex soutient Bernicot dans sa volonté de mobiliser
        une communauté mondiale de défenseurs des récifs et de préserver les
        écosystèmes coralliens dans le monde entier», écrit la firme.
      </StandardParagraph>
      <StandardParagraph>
        Comment Rolex gère-t-elle cette contradiction? Interrogée, une
        porte-parole de l'entreprise souligne que la firme n'utilise les deux
        avions privés qu'à des fins professionnelles. «Notre présence
        internationale, le développement et la gestion de notre société
        requièrent des déplacements de cet ordre.» Les avions seraient
        exclusivement réservés aux instances dirigeantes de la firme, dont le
        besoin est de «se déplacer rapidement, en toute sécurité et toute
        confidentialité partout dans le monde», explique Virginie Chevailler-de
        Meuron, porte-parole de Rolex.
      </StandardParagraph>
      <StandardParagraph>
        Interrogée sur les trajets courts, Rolex laisse entendre qu'elle
        pourrait changer de cap: «Les courtes distances sont actuellement à
        l'étude, comme toutes les autres mesures qui nous permettront de réduire
        notre empreinte carbone», précise Mme Chevailler-de Meuron. L'entreprise
        étudierait la compensation des émissions ou l'utilisation de carburant
        durable.
      </StandardParagraph>
    </FrontElement>,
  ],
}
